import React, { useEffect, useState } from 'react'
import { Pagination, Table } from 'react-bootstrap'
import { projectTransactions } from '../../utils/services/service'
import useWeb3 from '../../hooks/useWeb3'
import { getFormatedWeb3Address, getTimeInAges, getTransactionHash } from '../../utils/helpers'
import { useSocketEvents } from '../../hooks/dataFetcher/Socket'


const Transactiontable = ({ ticker, name, isMobile = false, contractAddress }) => {
    const [transactionDetails, setTransactionDetails] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const web3 = useWeb3();
    const pair = `ETH/${ticker}`
    const socketEvent = `${pair}-${contractAddress}`

    const events = [
        {
            eventName: socketEvent,
            handler: (data) => {
                if (data !== null) {
                    setTransactionDetails([data, ...transactionDetails])
                }
            },
        }
    ];
    useSocketEvents(events);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const pageItems = [];
    for (let i = 1; i <= totalPages; i++) {
        pageItems.push(i);
    }

    const getProjectTransactions = async () => {
        const transactions = await projectTransactions(pair, currentPage)
        if (transactions) {
            setTransactionDetails(transactions?.projects)
            setTotalPages(transactions?.totalPages)
            setTotalItems(transactions?.total)
        }
    }

    useEffect(() => {
        if (ticker) getProjectTransactions()
    }, [ticker, currentPage])

    const formateValues = (value) => {
        const formattedValue = web3.utils.fromWei(value, "ether")
        return Number(formattedValue)?.toFixed(6)
    }

    return (
        <>
            <div className={`tabone_Data  ${isMobile ? 'phone_view' : 'dessktop_view'}`}>
                <Table responsive>
                    <thead>
                        <tr>
                            <th className="leftside">
                                <div className="thdata">
                                    <p>Account</p>

                                </div>
                            </th>
                            <th>
                                <div className="thdata">
                                    <p>Type</p>

                                </div>
                            </th>
                            <th>
                                <div className="thdata">
                                    <p>ETH</p>

                                </div>
                            </th>
                            <th>
                                <div className="thdata">
                                    <p>{name}</p>
                                </div>
                            </th>
                            <th>
                                <div className="thdata">
                                    <p>Date</p>

                                </div>
                            </th>
                            <th>
                                <div className="thdata">
                                    <p>Transaction</p>

                                </div>
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {transactionDetails?.map((res) => {
                            return (
                                <tr>
                                    <td>
                                        <div className="leftside">
                                            <div className="inner_td">
                                                <h1>{getFormatedWeb3Address(res?.userAddress, true)}</h1>
                                            </div>
                                        </div>

                                    </td>
                                    <td>
                                        {res?.tradeType === 'BUY' ? <h5>{res?.tradeType}</h5> : <h6>{res?.tradeType}</h6>}
                                    </td>
                                    <td>
                                        {res?.tradeType === 'BUY' ? <h5>{formateValues(res?.amountIn)}</h5> : <h6>{formateValues(res?.amountOut)}</h6>}
                                    </td>
                                    <td>
                                        <h3>{res?.tradeType === 'BUY' ? <h5>{Number(formateValues(res?.amountOut))?.toFixed(2)}</h5> : <h6>{Number(formateValues(res?.amountIn))?.toFixed(2)}</h6>}</h3>
                                    </td>
                                    <td>
                                        <h3>{getTimeInAges(res?.createdAt)}</h3>
                                    </td>
                                    <td>
                                        <a className='innner_data_tablee' href={getTransactionHash(res?.txHash)} target="_blank">
                                            <h3>{getFormatedWeb3Address(res?.txHash, false)} </h3>
                                            <svg className='sendd' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                <path d="M15.75 7.3125C15.75 7.46168 15.6907 7.60476 15.5852 7.71025C15.4798 7.81574 15.3367 7.875 15.1875 7.875C15.0383 7.875 14.8952 7.81574 14.7898 7.71025C14.6843 7.60476 14.625 7.46168 14.625 7.3125V4.17094L9.96117 8.83547C9.85562 8.94102 9.71247 9.00031 9.5632 9.00031C9.41394 9.00031 9.27078 8.94102 9.16523 8.83547C9.05969 8.72992 9.00039 8.58677 9.00039 8.4375C9.00039 8.28823 9.05969 8.14508 9.16523 8.03953L13.8291 3.375H10.6875C10.5383 3.375 10.3952 3.31574 10.2898 3.21025C10.1843 3.10476 10.125 2.96168 10.125 2.8125C10.125 2.66332 10.1843 2.52024 10.2898 2.41475C10.3952 2.30926 10.5383 2.25 10.6875 2.25H15.1875C15.3367 2.25 15.4798 2.30926 15.5852 2.41475C15.6907 2.52024 15.75 2.66332 15.75 2.8125V7.3125ZM12.9375 9C12.7883 9 12.6452 9.05926 12.5398 9.16475C12.4343 9.27024 12.375 9.41332 12.375 9.5625V14.625H3.375V5.625H8.4375C8.58668 5.625 8.72976 5.56574 8.83525 5.46025C8.94074 5.35476 9 5.21168 9 5.0625C9 4.91332 8.94074 4.77024 8.83525 4.66475C8.72976 4.55926 8.58668 4.5 8.4375 4.5H3.375C3.07663 4.5 2.79048 4.61853 2.5795 4.8295C2.36853 5.04048 2.25 5.32663 2.25 5.625V14.625C2.25 14.9234 2.36853 15.2095 2.5795 15.4205C2.79048 15.6315 3.07663 15.75 3.375 15.75H12.375C12.6734 15.75 12.9595 15.6315 13.1705 15.4205C13.3815 15.2095 13.5 14.9234 13.5 14.625V9.5625C13.5 9.41332 13.4407 9.27024 13.3352 9.16475C13.2298 9.05926 13.0867 9 12.9375 9Z" fill="#311E1A" />
                                            </svg>
                                        </a>

                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <div className="pagination_mains">

                    <div>
                        <h6>SHOWING {(currentPage - 1) * 10 + 1}-{Math.min(currentPage * 10, totalItems)} OF {totalItems}</h6>
                    </div>
                    <div className="innner_pagi">
                        <Pagination >
                            {
                                totalPages > 1 &&
                                <div className='rightsideee'>
                                    <img
                                        src="/asset/leftarrow.svg"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        style={{ cursor: 'pointer' }}
                                        className='imggggggright'
                                    />
                                </div>
                            }
                            {currentPage > 5 && <Pagination.Ellipsis />}
                            {pageItems.slice(Math.max(currentPage - 3, 0), Math.min(currentPage + 2, totalPages - 1)).map((page) => (
                                <Pagination.Item
                                    key={page}
                                    active={page === currentPage}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            ))}
                            {currentPage < totalPages - 2 && <Pagination.Ellipsis />}
                            {totalPages > 1 && (
                                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                                    {totalPages}
                                </Pagination.Item>
                            )}
                            {
                                totalPages > 1 &&
                                <div className='rightsideee'>
                                    <img
                                        src="/asset/rightarrow.svg"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        style={{ cursor: 'pointer' }}
                                        className='imggggggright'
                                    />
                                </div>
                            }
                        </Pagination>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Transactiontable